import React from 'react';

const Min = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 8L3 8" stroke="#ADADAD" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default Min;
